import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useServices } from 'lib/hooks/queries/services/useServices';
import useModal from 'lib/hooks/useModal';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

import AddServicesModal from './components/AddServicesModal/AddServicesModal';
import EditServiceModal from './components/EditServiceModal';
import { scheduleOfFeesMainColumns } from './lib/helpers';

const EmptyServicesState = ({ onAddServices }) => {
  return (
    <div className="flex w-full flex-col items-center pb-20">
      <Icon icon="illustration-empty-table" />
      <h1 className="text-base font-500 text-primary-900">No services added yet!</h1>
      <p className="text-sm text-neutral-700">
        Add services to define your practice's schedule of fees
      </p>
      <Button
        className="mt-4"
        textClassName="whitespace-nowrap"
        text="Add services"
        icon="add-square-mono"
        size="xs"
        variant="link"
        onClick={onAddServices}
      />
    </div>
  );
};

const ScheduleOfFees = ({
  addFooterActions,
  setHeaderButtonProps,
  mutateOrchestratorData,
  orchestratorLoading
}) => {
  const { id: practiceId } = useParams();
  const { isOpen, openModal, closeModal } = useModal();

  const columnDefs = useMemo(() => scheduleOfFeesMainColumns, []);

  useEffect(() => {
    setHeaderButtonProps({
      text: 'Add services',
      onClick: openModal,
      icon: 'add-square-mono'
    });

    addFooterActions([
      {
        text: 'Continue',
        onClick: () => {
          mutateOrchestratorData({});
        },
        isDisabled: orchestratorLoading
      }
    ]);
  }, [
    orchestratorLoading,
    openModal,
    setHeaderButtonProps,
    addFooterActions,
    mutateOrchestratorData
  ]);

  const CustomNoRowsOverlay = () => <EmptyServicesState onAddServices={openModal} />;

  return (
    <div className="mb-4 flex flex-1 flex-col">
      <AgTablePage
        defaultColumns={columnDefs}
        useData={useServices}
        title="Services"
        name="services"
        noHeader
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ forPractice: false, getPayers: true, practiceId: Number(practiceId) }}
        queryOptions={{ refetchOnMount: 'always' }}
        ModalComponent={EditServiceModal}
        autoHeight
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200"
        noRowsOverlayComponent={CustomNoRowsOverlay}
      />

      {isOpen && <AddServicesModal isOpen={isOpen} onClose={closeModal} />}
    </div>
  );
};

export default ScheduleOfFees;
